import React from 'react'
import { motion } from 'framer-motion'
import { Box, Typography, useMediaQuery } from '@material-ui/core'

const DestinationPanel = ({ 
  destination, 
  isSelected, 
  onSelect, 
  onClick, 
  imageSrc, 
  title, 
  description,
  color 
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const isSmall = useMediaQuery('(max-width: 1024px)')

  return (
    <motion.div
      initial={{ opacity: 0, x: destination === 'resume' ? -100 : 100 }}
      animate={{ 
        opacity: 1, 
        x: 0,
        scale: isSelected ? 1.05 : 1
      }}
      transition={{ duration: 0.5 }}
      onMouseEnter={onSelect}
      onClick={onClick}
      style={{
        flex: 1,
        cursor: 'pointer',
        position: 'relative'
      }}
    >
      <Box style={{
        position: 'relative',
        border: `4px solid ${isSelected ? color : `rgba(${color === '#00ffff' ? '0, 255, 255' : '255, 0, 255'}, 0.3)`}`,
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: isSelected 
          ? `0 0 60px ${color}80, inset 0 0 40px ${color}33` 
          : `0 0 20px ${color}4D`,
        transition: 'all 0.3s ease',
        background: `rgba(${color === '#00ffff' ? '0, 20, 30' : '30, 0, 30'}, 0.6)`,
        backdropFilter: 'blur(10px)'
      }}>
        {isSelected && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              fontFamily: '"Orbitron", monospace',
              fontSize: '0.8rem',
              color,
              background: `${color}33`,
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              border: `1px solid ${color}`,
              textShadow: `0 0 10px ${color}`,
              zIndex: 10
            }}
          >
            ◉ TARGET LOCKED
          </motion.div>
        )}
        
        <img
          src={imageSrc}
          alt={`${destination} Destination`}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            opacity: isSelected ? 1 : 0.6,
            transition: 'opacity 0.3s ease'
          }}
        />
        
        <Box style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: isMobile ? '1rem' : '2rem',
          background: `linear-gradient(0deg, rgba(${color === '#00ffff' ? '0, 20, 30' : '30, 0, 30'}, 0.95) 0%, transparent 100%)`
        }}>
          <Typography style={{
            fontFamily: '"Orbitron", monospace',
            fontSize: isMobile ? '1rem' : isSmall ? '1.1rem' : '1.5rem',
            color,
            fontWeight: 'bold',
            textShadow: `0 0 20px ${color}`,
            marginBottom: isMobile ? '0.25rem' : '0.5rem',
            letterSpacing: '0.1em'
          }}>
            {title}
          </Typography>
          {!isMobile && (
            <Typography style={{
              fontFamily: '"Share Tech Mono", monospace',
              fontSize: isSmall ? '0.75rem' : '0.9rem',
              color: '#ccc',
              marginBottom: isSmall ? '0.5rem' : '1rem'
            }}>
              {description}
            </Typography>
          )}
          {isSelected && !isMobile && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              style={{
                fontFamily: '"Orbitron", monospace',
                fontSize: isSmall ? '0.7rem' : '0.85rem',
                color,
                textShadow: `0 0 10px ${color}`
              }}
            >
              ▶ PRESS ENTER TO ACTIVATE
            </motion.div>
          )}
        </Box>
      </Box>
    </motion.div>
  )
}

export default DestinationPanel
